<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Adicionar Empresa ao {{this.park.initials}}</h3>
          </div>
          <CompanyForm :company="company" :errors="errors" :onSubmit="onSubmit"></CompanyForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import ParkClient from '@/services/resource_client/park'
import CompanyClient from '@/services/resource_client/company'
import CompanyForm from '@/pages/companies/CompanyForm'

export default {
  name: 'CreateCompany',
  props: ['parkId'],
  components: { Adminlte, CompanyForm },
  data: function () {
    return {
      company: {},
      park: {},
      errors: {}
    }
  },
  created () {
    ParkClient.get(this.parkId)
    .then(r => { this.park = r.data })
  },
  methods: {
    onSubmit () {
      CompanyClient.post(this.parkId, this.company)
      .then(r => { this.$router.push({ name: 'CompaniesHome', params: { parkId: this.parkId } }) })
      .catch(e => { this.errors = e.response.data.errors })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateCompany.vue?6d46965a